import React, { useEffect, useState, useRef, useMemo } from "react";
import { connect } from "react-redux";
import translate from "../../../i18n/translate";
import { useHistory } from "react-router-dom";
import Selected from "./Selected";
import SubNavOoredoo from "./SubNavOoredoo";
import {
  getOoredooRom,
  getOoredooRomRenew,
  getOoredooRomNotRenew,
} from "../../../actions/companiesAction";
import Spinner from "../../ui/spinner/Spinner";
import Badge from "../../ui/Badge/Badge";
import _ from "lodash";
import "./ooredoo.css";
import { dataLanguage } from "../../../i18n/translateRequest";
import CompaniesNav from "../../common/CompaniesNav";
import logo from "../../../assests/images/bundles/ooredoo/banner.jpg";
import { jsonParser } from "shared/utils/ppUtils";
import { Box, Tabs, Tab } from "@mui/material";
import OoredooBundleCard from "./OoredooBundleCard";
import getOoredooCachedImageUrl from "shared/utils/ooredooImageCache";

const RomOoredoo = ({
  getOoredooRom,
  ooredooRom,
  loading,
  getOoredooRomRenew,
  getOoredooRomNotRenew,
  isDarkTheme,
}) => {
  const history = useHistory().location.pathname;
  const mobileNo = history.split("/")[4];

  const [isRenew, setIsRenew] = useState(false);
  const [isNotRenew, setIsNotRenew] = useState(false);
  const [init, isInit] = useState(false);

  const [g3, setG3] = useState("");
  const [min, setMin] = useState("");
  const [credit, setCredit] = useState("");
  const [creditQueue, setCreditQueue] = useState([]);
  const [rom, setRom] = useState("");
  const [shabab, setShabab] = useState("");
  const [groupedRom, setGroupedRom] = useState({});
  const [selectedCountry, setSelectedCountry] = useState("");
  const [columnStyle, setColumnStyle] = useState(
    "col-lg-3 col-md-4 col-sm-6 col-6"
  );
  const [imageRefreshToken, setImageRefreshToken] = useState(0);
  const collapseRef = useRef([]);
  const listRef = useRef(null);

  const handleCreditQueueChange = (queue) => {
    setCreditQueue(queue || []);
    setCredit(queue?.[queue.length - 1] || "");
  };

  useEffect(() => {
    getOoredooRom(false);

    const handleSessionStorageChange = () => {
      document.title = "Ooredoo  Rom | Phone Play";

      if (sessionStorage.ooredoo3g) {
        setG3(jsonParser(sessionStorage.ooredoo3g));
      }
      if (sessionStorage.ooredooMin) {
        setMin(jsonParser(sessionStorage.ooredooMin));
      }
      // Load credit queue from sessionStorage
      if (sessionStorage.ooredooCreditQueue) {
        const parsedQueue = jsonParser(sessionStorage.ooredooCreditQueue);
        if (Array.isArray(parsedQueue) && parsedQueue.length) {
          handleCreditQueueChange(parsedQueue);
        }
      } else if (sessionStorage.ooredooCredit) {
        const parsedCredit = jsonParser(sessionStorage.ooredooCredit);
        if (parsedCredit) {
          handleCreditQueueChange([parsedCredit]);
        }
      } else {
        handleCreditQueueChange([]);
      }
      if (sessionStorage.ooredooRom) {
        setRom(jsonParser(sessionStorage.ooredooRom));
      }
      if (sessionStorage.ooredooSuper) {
        setShabab(jsonParser(sessionStorage.ooredooSuper));
      }
      refreshColumnStyle();
    };

    handleSessionStorageChange();

    window.addEventListener(
      "sessionStorageChanged",
      handleSessionStorageChange
    );

    // Clean up the event listener
    return () => {
      window.removeEventListener(
        "sessionStorageChanged",
        handleSessionStorageChange
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileNo, history]);

  useEffect(() => {
    if (init) {
      getOoredooPackages();
    }
    isInit(true);

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRenew, isNotRenew]);

  useEffect(() => {
    if (Array.isArray(ooredooRom) && ooredooRom.length) {
      const grouped = ooredooRom.reduce((acc, bundle) => {
        const rawCountry =
          typeof bundle?.country === "string" && bundle.country.trim().length
            ? bundle.country.trim()
            : translate("ooredoo_rom_unknown_country");
        if (!acc[rawCountry]) {
          acc[rawCountry] = [];
        }
        acc[rawCountry].push(bundle);
        return acc;
      }, {});
      setGroupedRom(grouped);
      const availableCountries = Object.keys(grouped);
      if (!selectedCountry || !grouped[selectedCountry]) {
        setSelectedCountry(availableCountries.sort((a, b) =>
          a.localeCompare(b)
        )[0]);
      }
    } else {
      setGroupedRom({});
      setSelectedCountry("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ooredooRom, translate]);

  const orderedCountries = useMemo(() => {
    return Object.keys(groupedRom).sort((a, b) => a.localeCompare(b));
  }, [groupedRom]);

  const currentCountryBundles = useMemo(() => {
    if (!selectedCountry) return [];
    return groupedRom[selectedCountry] || [];
  }, [groupedRom, selectedCountry]);

  const handleClickOutside = (event) => {
    if (listRef.current && !listRef.current.contains(event.target)) {
      collapseRef.current.forEach((item) => {
        item?.classList?.remove("show");
      });
    }
  };

  const onTypeClick = (item) => {
    setRom(item);
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });

    sessionStorage.ooredooRom = JSON.stringify(item);
  };

  const onRenewClick = () => {
    setIsRenew(!isRenew);
    setIsNotRenew(false);
    isInit(true);
  };
  const onNotRenewClick = () => {
    setIsNotRenew(!isNotRenew);
    setIsRenew(false);
    isInit(true);
  };
  const getOoredooPackages = () => {
    if (!isRenew && !isNotRenew) {
      getOoredooRom(false);
    } else if (isRenew) {
      getOoredooRomRenew();
    } else if (isNotRenew) {
      getOoredooRomNotRenew();
    }
  };
  const refreshClick = () => {
    setImageRefreshToken(Date.now());
    getOoredooRom(true);
  };

  const refreshColumnStyle = () => {
    switch (localStorage.size) {
      case "default":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
        break;
      case "column3":
        setColumnStyle("col-lg-4 col-md-6 col-sm-6 col-6 card-lg");
        break;
      case "column4":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6  card-md");
        break;
      case "column6":
        setColumnStyle("col-lg-2 col-md-2 col-sm-4 col-6 card-sm");
        break;
      default:
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
    }
  };
  let topDiv = null;

  return (
    <>
      <div ref={(ref) => (topDiv = ref)}>
        <div className="ooredoo-container">
          <CompaniesNav
            providerId={window?.history?.state?.state?.provider_Id}
            title="Ooredoo"
            logo={logo}
            mobile={mobileNo}
            onRefresh={refreshClick}
            actionWidth="300px"
            backLink="/company/ooredoo/MobileNumer"
          >
            <button
              type="button"
              className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
                isRenew ? "selected-btn" : ""
              }`}
              onClick={onRenewClick}
            >
              {translate("Renewable")}
            </button>
            <button
              type="button"
              className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
                isNotRenew ? "selected-btn" : ""
              }`}
              onClick={onNotRenewClick}
            >
              {translate("notRenew")}
            </button>
          </CompaniesNav>

          <div className="row">
            <div className="col-12">
              <SubNavOoredoo mobile={mobileNo} />
            </div>
          </div>
        </div>
        <div className="position-relative">
          <Selected
            min={min}
            setMin={setMin}
            g3={g3}
            setg3={setG3}
            credit={credit}
            setCredit={setCredit}
            creditQueue={creditQueue}
            onCreditQueueChange={handleCreditQueueChange}
            shabab={shabab}
            setShabab={setShabab}
            setRom={setRom}
            rom={rom}
            imageRefreshToken={imageRefreshToken}
          />

          <hr
            className="mt-3"
            style={{
              border: "2px solid #42ace3",
              backgroundColor: "#42ace3",
              fontWeight: "bolder",
            }}
          />

          <div
            className={`${isDarkTheme ? "dark-card" : "card"} list-cards p-4`}
            ref={listRef}
          >
            {orderedCountries.length > 0 && (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  marginBottom: 2,
                }}
              >
                <Tabs
                  value={selectedCountry || false}
                  onChange={(_, newValue) => setSelectedCountry(newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {orderedCountries.map((countryKey) => (
                    <Tab
                      key={countryKey}
                      value={countryKey}
                      label={countryKey}
                    />
                  ))}
                </Tabs>
              </Box>
            )}
            <div className="row">
              {!orderedCountries.length && !loading ? (
                <div className="d-flex justify-content-center mt-3">
                  <h2 className="text-info">
                    {translate("No available bundles")}
                  </h2>
                </div>
              ) : (
                currentCountryBundles.map((item, index) => (
                  <div key={index.toString()} className={`${columnStyle} mt-3`}>
                    <div
                      className={`${
                        isDarkTheme ? "dark-card" : "card"
                      } charge-card`}
                    >
                      <a
                        style={{ cursor: "pointer" }}
                        data-placement="top"
                        title={item && item.des}
                        onClick={() => onTypeClick(item)}
                      >
                        <div className="position-relative">
                          <OoredooBundleCard
                            item={item}
                            size={localStorage.size || "default"}
                          />
                          {(item.auto_renew === "True" ||
                            item.auto_renew === "true") && (
                            <Badge text={translate("Renewable")}></Badge>
                          )}
                        </div>
                      </a>
                    </div>
                    <div className={`${isDarkTheme ? "dark-card" : "card"}`}>
                      <div className="text-center" id="headingOne">
                        <h5 className="mb-0 mx-">
                          <a
                            href="#0"
                            className="link-main details"
                            style={{ fontWeight: "bolder" }}
                            data-toggle="collapse"
                            data-target={"#" + index}
                            aria-expanded="true"
                            aria-controls={index}
                          >
                            <small>{translate("Details")}</small>
                          </a>
                        </h5>
                      </div>

                      <div
                        id={index}
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                        ref={(el) => (collapseRef.current[index] = el)}
                      >
                        <div className="card-body">
                          {dataLanguage(item, "ar-des", "en-des", "he-des")}
                          <br />
                          <p style={{ textAlign: "center" }}>{item.bundleid}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  ooredooRom: state.companies.ooredooRom,
  loading: state.companies.loading,
  isDarkTheme: state.darkTheme.isDarktheme,
});
export default connect(mapStateToProps, {
  getOoredooRom,
  getOoredooRomRenew,
  getOoredooRomNotRenew,
})(RomOoredoo);
